export default __webpack_public_path__ + "static/media/2171.3858d717.png";